/* =========================================================
   SANE SEITY — Theme JavaScript
   ========================================================= */

(function () {
  'use strict';

  /* --- Mobile nav ----------------------------------------- */
  const mobileToggle = document.querySelector('.header-mobile-toggle');
  const mobileNav    = document.querySelector('.header-mobile-nav');
  const mobileClose  = document.querySelector('.header-mobile-nav-close');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* --- Accordion ------------------------------------------ */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.accordion-item.is-open').forEach(el => {
        el.classList.remove('is-open');
      });

      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });

  /* --- Product media gallery ------------------------------ */
  const thumbs  = document.querySelectorAll('.product-media-thumb');
  const mainImg = document.querySelector('.product-media-main img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;

      if (mainImg && src) {
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
      }

      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* --- Variant / size selection --------------------------- */
  const sizeBtns = document.querySelectorAll('.size-btn');
  const variantIdInput = document.querySelector('[name="id"]');

  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-unavailable')) return;

      sizeBtns.forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      if (variantIdInput && btn.dataset.variantId) {
        variantIdInput.value = btn.dataset.variantId;
      }

      // Update price display
      const priceEl = document.querySelector('.product-details-price');
      if (priceEl && btn.dataset.price) {
        priceEl.textContent = btn.dataset.price;
      }
    });
  });

  /* --- Newsletter form ------------------------------------ */
  const newsletterForms = document.querySelectorAll('.newsletter-form');

  newsletterForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('.newsletter-input');
      const submit = form.querySelector('.newsletter-submit');

      if (!input || !input.value.trim()) {
        e.preventDefault();
        return;
      }

      submit.textContent = 'Submitted';
      submit.disabled = true;
    });
  });

  /* --- Cookie consent banner ------------------------------ */
  const CONSENT_KEY = 'sane-seity-consent';
  const banner = document.querySelector('.cookie-banner');

  function readConsent() {
    try {
      return JSON.parse(localStorage.getItem(CONSENT_KEY));
    } catch (err) {
      return null;
    }
  }

  function writeConsent(state) {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify(state));
    } catch (err) {}
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'analytics_storage':  state.analytics ? 'granted' : 'denied',
        'ad_storage':         state.marketing ? 'granted' : 'denied',
        'ad_user_data':       state.marketing ? 'granted' : 'denied',
        'ad_personalization': state.marketing ? 'granted' : 'denied'
      });
    }
  }

  function hideBanner() {
    if (banner) banner.hidden = true;
  }

  function showBanner() {
    if (banner) banner.hidden = false;
  }

  // First visit (no stored choice) → show banner
  if (banner && !readConsent()) {
    showBanner();
  }

  const acceptBtn = document.querySelector('.cookie-banner-accept');
  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      writeConsent({ analytics: true, marketing: true, ts: Date.now() });
      hideBanner();
    });
  }

  const rejectBtn = document.querySelector('.cookie-banner-reject');
  if (rejectBtn) {
    rejectBtn.addEventListener('click', () => {
      writeConsent({ analytics: false, marketing: false, ts: Date.now() });
      hideBanner();
    });
  }

  // Any link or button with data-cookie-settings re-opens the banner
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cookie-settings]');
    if (trigger) {
      e.preventDefault();
      showBanner();
    }
  });

  /* --- Page transition: film grain dissolve --------------- */
  const grain = document.querySelector('.page-transition-grain');

  if (grain) {
    // Flash on page load
    grain.classList.add('is-loading');
    window.setTimeout(() => {
      grain.classList.remove('is-loading');
    }, 320);

    // Persistent overlay on internal link click — masks the white flash
    // between this page unloading and the next one painting
    document.addEventListener('click', (e) => {
      if (e.defaultPrevented) return;
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
      if (e.button !== 0) return;

      const link = e.target.closest('a');
      if (!link) return;
      if (link.target && link.target !== '_self') return;
      if (link.hasAttribute('download')) return;

      const href = link.getAttribute('href');
      if (!href) return;
      if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

      let url;
      try {
        url = new URL(href, window.location.href);
      } catch (err) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;

      grain.classList.remove('is-loading');
      grain.classList.add('is-navigating');
    });

    // If the user uses back/forward cache, re-flash on restore
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        grain.classList.remove('is-navigating');
        grain.classList.add('is-loading');
        window.setTimeout(() => grain.classList.remove('is-loading'), 320);
      }
    });
  }

})();
